import React from 'react'
import {
  Div,
  List,
  ListItem,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { Button } from 'src/chrome'
import { planDetails } from '../../constants'
import planContentStyles from '../PlanContentsGrid/planContentsGrid.module.scss'

type BasicPlanProps = {
  onSelect: (planTitle: string) => void
}

const BasicPlan: React.FC<BasicPlanProps> = props => {
  const { onSelect } = props
  const planData = planDetails.find(p => p.plan === 'Basic')

  return (
    <Div
      className={`${planContentStyles.featureGridContainer} ${planContentStyles.offWhite}`}
    >
      <Div className={planContentStyles.featureGrid}>
        <Text
          type="subtitle"
          content="Or you can pay as you go with our Basic Account!"
        />
        <Spacer space="x1" />
        <Text type="caption">
          Not ready to commit to a subscription? With a Basic Account, you can
          send cards for $2.75 a piece, plus postage! Once you try out our
          system, you can always upgrade later!
        </Text>
        <Spacer space="x1_5" />
        {planData && (
          <List
            alignment="left"
            orientation="vertical"
            css={{ paddingLeft: '2em' }}
          >
            {planData.details &&
              planData.details.map(detail => (
                <ListItem
                  key={detail.detail}
                  orientation="horizontal"
                  css={{ listStyle: 'disc' }}
                >
                  {detail.innerDetails && (
                    <>
                      <Text type="footnote">{detail.detail}</Text>
                      <List alignment="left" orientation="vertical">
                        {detail.innerDetails.map(innerDetail => (
                          <ListItem
                            orientation="horizontal"
                            key={innerDetail.detail}
                            css={{ listStyle: 'circle', marginLeft: '1em' }}
                          >
                            <Text type="footnote">{innerDetail.detail}</Text>
                          </ListItem>
                        ))}
                      </List>
                    </>
                  )}
                  {!detail.innerDetails && (
                    <Text type="footnote">{detail.detail}</Text>
                  )}
                </ListItem>
              ))}
          </List>
        )}
        <Spacer space="x4" />
        <Button title="Select" onClick={() => onSelect('Basic')} />
      </Div>
    </Div>
  )
}

export default BasicPlan
